import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/a/')({
  component: Component,
});

function Component() {
  return <div>Hello /admin yes!/!</div>;
}
